import React from 'react';
import Button from '../button';
import Title from '../title';
import { AiOutlinePlus } from 'react-icons/ai';

interface IProps {
  title: string;
  btnTxt: string;
  icon?: any;
  onClick?: () => void;
}

const HeadingWithCreateBtn: React.FC<IProps> = ({
  title,
  btnTxt,
  onClick,
  icon,
}) => {
  return (
    <div className=" w-full  flex items-center justify-between">
      <Title text={title} />
      <Button text={btnTxt} variant="primary" onClick={onClick} icon={icon} />
    </div>
  );
};

export default React.memo(HeadingWithCreateBtn);
